module.exports = __webpack_public_path__ + "static/media/YESBANK.1555f8bf.svg";